//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { AddSubscriptionsRequest } from './models/AddSubscriptionsRequest';
import type { AddSubscriptionsResponse } from './models/AddSubscriptionsResponse';
import { Utilities } from './Utilities';

export class AddSubscriptionsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        post: (): string => {
            let clientRequestUrl = '/api/v1/subscriptions';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Add or update subscriptions.
     * @param body (optional) The parameter to add multiple subscriptions. For medium, possible values: email, notification, emailWithNotification. When passing an Id, the subscription is updated directly with the value of the medium.
     * @return OK
     */
    async post(
        body?: AddSubscriptionsRequest,
    ): Promise<AddSubscriptionsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.post();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<AddSubscriptionsResponse>(_response, false, []);
    }
}
